import { createSelector } from 'reselect';

const metaSelector = state => state.meta;
const routingSelector = state => state.routing;
const userPermissionsSelector = state => state.ustate.perms;

export default createSelector(
	[metaSelector,routingSelector,userPermissionsSelector],
	(meta, routing, userPermissions) => {
		return {
			...meta,
			userPermissions,
			routing
		};
	}
);


// WEBPACK FOOTER //
// ./src/selectors/metaSelector.js